import { REFERENCE_LINE_DIRECTION } from './constants';
import type { ReferenceLine, ReferenceLinesStageHistoryExtension } from './types';

/** 校验单条舞台历史扩展中的参考线快照成员。 */
const isReferenceLine = (value: unknown): value is ReferenceLine => {
    if (!value || typeof value !== 'object') return false;
    const line = value as Partial<ReferenceLine>;
    return (
        typeof line.id === 'string' &&
        (line.direction === REFERENCE_LINE_DIRECTION.HORIZONTAL ||
            line.direction === REFERENCE_LINE_DIRECTION.VERTICAL) &&
        typeof line.position === 'number' &&
        Number.isFinite(line.position)
    );
};

/**
 * 校验 reference-lines 自有的舞台历史扩展数据。
 * 畸形或其他插件的数据必须被忽略，不能阻断舞台核心历史恢复。
 */
export const isReferenceLinesStageHistoryExtension = (value: unknown): value is ReferenceLinesStageHistoryExtension => {
    if (!value || typeof value !== 'object') return false;
    const extension = value as Partial<ReferenceLinesStageHistoryExtension>;
    return (
        Array.isArray(extension.oldLines) &&
        extension.oldLines.every(isReferenceLine) &&
        Array.isArray(extension.newLines) &&
        extension.newLines.every(isReferenceLine)
    );
};
